var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4832 31.4259C36.3218 32.288 37.7377 32.2248 38.3778 31.2067C40.5458 27.7581 41 24.4594 41 21C41 17.4788 40.1071 13.3843 38.2832 10.5215C37.6911 9.59222 36.4175 9.56626 35.6205 10.3271L27.6862 17.9016C25.8111 19.9672 25.8111 21.3443 27.6862 23.4098L35.4832 31.4259ZM32.1793 35.107C33.0247 35.8945 33.0335 37.2409 32.1152 37.942C28.7732 40.4932 24.6486 42 20.1856 42C9.03742 42 0 32.598 0 21C0 9.40202 9.03742 0 20.1856 0C24.4962 0 28.4912 1.40565 31.7702 3.80038C32.6995 4.47913 32.7232 5.81907 31.9028 6.62612L22.7436 15.6359C22.1635 16.2066 21.3953 16.5246 20.5968 16.5246C18.8711 16.5246 17.4722 15.0692 17.4722 13.2738V10.3279C17.4722 8.7137 16.2277 7.40515 14.6925 7.40515C13.1573 7.40515 11.9128 8.7137 11.9128 10.3279V32.192C11.9128 33.8062 13.1573 35.1148 14.6925 35.1148C16.2277 35.1148 17.4722 33.8062 17.4722 32.192V28.7629C17.4722 26.9473 18.8869 25.4754 20.6322 25.4754C21.4101 25.4754 22.1606 25.7739 22.7402 26.3138L32.1793 35.107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo5);
export default __webpack_public_path__ + "static/media/logo-5.be67c5e24941e777483659044b58984d.svg";
export { ForwardRef as ReactComponent };